import { createSlice } from "@reduxjs/toolkit";

const librarySlice = createSlice({
  name: "libraryAdd",
  initialState: {
    isLibraryAddOpen: false,
  },
  reducers: {
    toogleLibraryAdd: (state) => {
      state.isLibraryAddOpen = !state.isLibraryAddOpen;
    },
  },
});

export const { toogleLibraryAdd } = librarySlice.actions;
export default librarySlice.reducer;